import { useState, useEffect } from 'react'

export type TimeType = {
  day: number
  hour: number
  min: number
  sec: number
  oneTenthMs: number
}
const useCountdown = (startingTime: TimeType) => {
  const [time, setTime] = useState<TimeType>(startingTime)
  const [, setTimerInterval] = useState(null)

  // scaling for useCountDown
  // day  :- return 1 day
  // hour :- return 1 hour
  // min  :- return 1 minute
  // sec  :- return 1 second
  // oneTenthMs   :- return 1/10 millisecond

  const stopCountDown = () =>
    setTimerInterval((interval) => {
      if (interval) {
        clearInterval(interval)
      }
      return null
    })

  useEffect(() => {
    const interval = setInterval(
      () =>
        setTime(({ day, hour, min, sec, oneTenthMs }) => {
          if (
            min <= 0 &&
            sec <= 0 &&
            oneTenthMs <= 0 &&
            hour <= 0 &&
            day <= 0
          ) {
            stopCountDown()
          } else if (
            min === 0 &&
            sec === 0 &&
            oneTenthMs === 0 &&
            hour === 0 &&
            day > 0
          ) {
            day--
            hour = 23
            min = 59
            sec = 59
            oneTenthMs = 99
          } else if (min === 0 && sec === 0 && oneTenthMs === 0 && hour > 0) {
            hour--
            min = 59
            sec = 59
            oneTenthMs = 99
          } else if (sec === 0 && oneTenthMs === 0) {
            min--
            sec = 59
            oneTenthMs = 99
          } else if (oneTenthMs === 0) {
            oneTenthMs = 99
            sec--
          } else {
            oneTenthMs--
          }

          // Turn negative numbers into 0 so -20 becomes 0
          return {
            day: Math.max(0, day),
            hour: Math.max(0, hour),
            min: Math.max(0, min),
            sec: Math.max(0, sec),
            oneTenthMs: Math.max(0, oneTenthMs),
          }
        }),
      10
    )

    setTimerInterval(interval)
    return stopCountDown
  }, [])

  return [time, stopCountDown] as const
}

export default useCountdown
